import { siteMapSX } from '@/components/content/SiteMap/styles/siteMapSX';
import { useLocalization } from '@/data/Localization';
import { Box, Link, Typography } from '@mui/material';
import NextLink from 'next/link';
import { useMemo } from 'react';
import { useGetCategories } from 'shared/custom/hooks/Categories';

const NUM_COLUMNS = 4;

export const DepartmentList = () => {
	const localization = useLocalization('SiteMap');
	const { navigation } = useGetCategories();

	const departments = useMemo(() => {
		if (!navigation || navigation.length === 0) return [];
		const allCats = navigation[0];
		if (!allCats?.children) return [];
		return [...allCats.children]
			.sort((a, b) => a.label.localeCompare(b.label, 'es'))
			.map((dept) => ({
				...dept,
				children: [...(dept.children ?? [])].sort((a, b) => a.label.localeCompare(b.label, 'es')),
			}));
	}, [navigation]);

	const columns = useMemo(() => {
		const total = departments.length;
		const baseSize = Math.floor(total / NUM_COLUMNS);
		const remainder = total % NUM_COLUMNS;
		const cols: (typeof departments)[] = [];
		let start = 0;
		for (let i = 0; i < NUM_COLUMNS; i++) {
			const size = baseSize + (i < remainder ? 1 : 0);
			cols.push(departments.slice(start, start + size));
			start += size;
		}
		return cols;
	}, [departments]);

	return (
		<>
			<Typography variant="headingFeatured" sx={siteMapSX.sectionHeader} component="h2">
				{localization.departmentsAZ.t()}
			</Typography>

			<Box sx={siteMapSX.departmentsGrid}>
				{columns.map((col, colIndex) => (
					<Box key={colIndex} sx={siteMapSX.departmentColumn}>
						{col.map((dept) => (
							<Box key={dept.uniqueID} sx={siteMapSX.departmentGroup}>
								<Link
									component={NextLink}
									href={dept.url ? `/b/${dept.url}` : '#'}
									underline="none"
									sx={siteMapSX.departmentTitle}
								>
									{dept.label}
								</Link>

								{dept.children?.map((cat) => (
									<Link
										key={cat.uniqueID}
										component={NextLink}
										href={cat.url ? `/b/${cat.url}` : '#'}
										underline="none"
										sx={siteMapSX.subcategoryLink}
									>
										{cat.label}
									</Link>
								))}
							</Box>
						))}
					</Box>
				))}
			</Box>
		</>
	);
};
